import React from "react";
import { useWindowWidth } from "../hooks/useWindowWidth";

export const LogoWithName = () => {

    const screenWidth = useWindowWidth();

    let logoWidth;
    if(screenWidth > 950){
      logoWidth = 850;
    }else {
      logoWidth = screenWidth - 100;
    }

    
    return (
    <svg xmlns="http://www.w3.org/2000/svg" width={screenWidth/2} viewBox="0 0 150.061 68.978">
  <defs>
    <clipPath id="clip-path">
      <path id="Path_2" data-name="Path 2" d="M98,35.16h56.246v42H98Zm0,0"/>
    </clipPath>
  </defs>
  <g id="Group_93" data-name="Group 93" transform="translate(-51.39 -35.16)">
    <g id="Group_1" data-name="Group 1" clip-path="url(#clip-path)">
      <path id="Path_1" data-name="Path 1" d="M152.457,44.16H138.172a8.8,8.8,0,0,1-2.121-.258,8.762,8.762,0,0,1-3.735-1.973,8.612,8.612,0,0,1-1.394-1.6,11.757,11.757,0,0,0-4.234-3.8,11.914,11.914,0,0,0-5.551-1.371h-9.332a9.672,9.672,0,0,0-4.66,1.168,9.976,9.976,0,0,0-1.344.887,9.206,9.206,0,0,0-1.176,1.1,9.352,9.352,0,0,0-.973,1.277,9.623,9.623,0,0,0-.738,1.422,9.332,9.332,0,0,0-.484,1.524L98.508,59.563a9.287,9.287,0,0,0-.234,1.8,9.4,9.4,0,0,0,.57,3.555,9.387,9.387,0,0,0,.789,1.633A9.644,9.644,0,0,0,100.723,68a9.6,9.6,0,0,0,4.625,2.809V77.16h3.039v-6a9.64,9.64,0,0,0,1.8-.266,9.5,9.5,0,0,0,1.718-.594,9.579,9.579,0,0,0,4.074-3.5,9.521,9.521,0,0,0,.833-1.6A9.356,9.356,0,0,0,117.5,61.7V44.16h-3.039v17.5a6.265,6.265,0,0,1-.129,1.266,6.668,6.668,0,0,1-.375,1.219,6.939,6.939,0,0,1-.609,1.121,6.789,6.789,0,0,1-.817.98,6.705,6.705,0,0,1-2.133,1.41,6.59,6.59,0,0,1-1.234.371,6.73,6.73,0,0,1-1.281.129A6.576,6.576,0,0,1,106.422,68a6.738,6.738,0,0,1-1.391-.48,6.541,6.541,0,0,1-2.285-1.8,6.464,6.464,0,0,1-1.273-2.6,6.451,6.451,0,0,1,0-2.891l3.922-17.008a6.439,6.439,0,0,1,2.3-3.648,6.53,6.53,0,0,1,4.114-1.406h9.332a8.741,8.741,0,0,1,5.855,2.227,8.485,8.485,0,0,1,1.391,1.6,11.814,11.814,0,0,0,4.238,3.8,11.952,11.952,0,0,0,5.551,1.375h8.418a6.041,6.041,0,0,0,.605,1.465,6.1,6.1,0,0,0,3.743,2.824v3.645a3.02,3.02,0,0,1-.149.934,3.089,3.089,0,0,1-.434.84,2.947,2.947,0,0,1-.679.664,2.9,2.9,0,0,1-.852.426,14.372,14.372,0,0,1-8.859-.582,4.551,4.551,0,0,0-1.512-.32,4.64,4.64,0,0,0-1.535.2,4.555,4.555,0,0,0-2.441,1.8l-1.52,2.277,2.539,1.652,1.52-2.266a1.485,1.485,0,0,1,.8-.594,1.5,1.5,0,0,1,1,.023,17.616,17.616,0,0,0,8.707,1.125,5.111,5.111,0,0,1-1.633,2.2,5.192,5.192,0,0,1-2.531,1.09l-8.1,1.23a8.4,8.4,0,0,0-1.449.344,8.575,8.575,0,0,0-1.36.59,8.417,8.417,0,0,0-2.3,1.848,8.551,8.551,0,0,0-.864,1.2,8.329,8.329,0,0,0-.633,1.332,7.829,7.829,0,0,0-.382,1.418,7.99,7.99,0,0,0-.125,1.465v3.18h3.039V73.98a5.22,5.22,0,0,1,1.289-3.457,5.249,5.249,0,0,1,1.472-1.176,5.32,5.32,0,0,1,1.8-.59l8.117-1.23a8.369,8.369,0,0,0,4.75-2.414,8.2,8.2,0,0,0,2.286-4.769,6.223,6.223,0,0,0,1.293-.949,5.931,5.931,0,0,0,1.836-4.3V45.66a1.512,1.512,0,0,0-.969-1.4A1.545,1.545,0,0,0,152.457,44.16Zm0,0" fill="#d9d9d9"/>
    </g>
    <g id="Group_4" data-name="Group 4">
      <g id="Group_3" data-name="Group 3" transform="translate(50.328 93.275)">
        <g id="Group_2" data-name="Group 2">
          <path id="Path_3" data-name="Path 3" d="M3.5-1.844H4.578A2.834,2.834,0,0,0,6.766-2.7a3.215,3.215,0,0,0,.8-2.281,3.248,3.248,0,0,0-.8-2.3,2.848,2.848,0,0,0-2.187-.859H3.5ZM4.578-9.984A5.62,5.62,0,0,1,8.5-8.594a4.662,4.662,0,0,1,1.531,3.609A4.634,4.634,0,0,1,8.5-1.391,5.6,5.6,0,0,1,4.578,0H1.063V-9.984Zm0,0" fill="#d9d9d9"/>
        </g>
      </g>
    </g>
    <g id="Group_7" data-name="Group 7">
      <g id="Group_6" data-name="Group 6" transform="translate(62.256 93.275)">
        <g id="Group_5" data-name="Group 5">
          <path id="Path_4" data-name="Path 4" d="M7.109-10.016v1.859H3.5v2.141H6.688v1.844H3.5v2.328H7.109V0H1.063V-10.016Zm0,0" fill="#d9d9d9"/>
        </g>
      </g>
    </g>
    <g id="Group_10" data-name="Group 10">
      <g id="Group_9" data-name="Group 9" transform="translate(71.81 93.275)">
        <g id="Group_8" data-name="Group 8">
          <path id="Path_5" data-name="Path 5" d="M7.563-10.016H10V0H7.563L3.5-6.3V0H1.063V-10.016H3.5l4.063,6.3Zm0,0" fill="#d9d9d9"/>
        </g>
      </g>
    </g>
    <g id="Group_13" data-name="Group 13">
      <g id="Group_12" data-name="Group 12" transform="translate(84.292 93.275)">
        <g id="Group_11" data-name="Group 11">
          <path id="Path_6" data-name="Path 6" d="M7.563-10.016H10V0H7.563L3.5-6.3V0H1.063V-10.016H3.5l4.063,6.3Zm0,0" fill="#d9d9d9"/>
        </g>
      </g>
    </g>
    <g id="Group_16" data-name="Group 16">
      <g id="Group_15" data-name="Group 15" transform="translate(96.775 93.275)">
        <g id="Group_14" data-name="Group 14">
          <path id="Path_7" data-name="Path 7" d="M1.063,0V-9.984H3.5V0Zm0,0" fill="#d9d9d9"/>
        </g>
      </g>
    </g>
    <g id="Group_19" data-name="Group 19">
      <g id="Group_18" data-name="Group 18" transform="translate(102.76 93.275)">
        <g id="Group_17" data-name="Group 17">
          <path id="Path_8" data-name="Path 8" d="M4.453-8.2a1.128,1.128,0,0,0-.75.25.821.821,0,0,0-.3.688,1.011,1.011,0,0,0,.266.734,1.887,1.887,0,0,0,.7.438c.289.094.613.188.969.281a8.164,8.164,0,0,1,1.063.328,4.735,4.735,0,0,1,.969.469,2.064,2.064,0,0,1,.7.8,2.723,2.723,0,0,1,.266,1.25A2.793,2.793,0,0,1,7.313-.8,4.013,4.013,0,0,1,4.594.094a4.294,4.294,0,0,1-2.7-.8A2.769,2.769,0,0,1,.859-3.016H3.438c.07.8.477,1.2,1.219,1.2a1.163,1.163,0,0,0,.828-.281.938.938,0,0,0,.3-.7.964.964,0,0,0-.266-.7,1.939,1.939,0,0,0-.7-.422c-.293-.1-.617-.2-.969-.281a9.884,9.884,0,0,1-1.062-.344,5.69,5.69,0,0,1-.953-.469,2,2,0,0,1-.7-.8A2.685,2.685,0,0,1,.859-7.047,2.719,2.719,0,0,1,1.891-9.281a4.032,4.032,0,0,1,2.641-.844,4.271,4.271,0,0,1,2.609.734A2.8,2.8,0,0,1,8.188-7.078H5.547a1.326,1.326,0,0,0-.359-.828A.977.977,0,0,0,4.453-8.2Zm0,0" fill="#d9d9d9"/>
        </g>
      </g>
    </g>
    <g id="Group_22" data-name="Group 22">
      <g id="Group_21" data-name="Group 21" transform="translate(119.068 93.275)">
        <g id="Group_20" data-name="Group 20">
          <path id="Path_9" data-name="Path 9" d="M1.969-1.359A4.857,4.857,0,0,1,.484-5.016,4.869,4.869,0,0,1,1.969-8.672a5,5,0,0,1,3.641-1.453,5.1,5.1,0,0,1,2.953.891,4.538,4.538,0,0,1,1.8,2.438H7.469A1.935,1.935,0,0,0,5.641-7.891a2.54,2.54,0,0,0-1.969.781,2.97,2.97,0,0,0-.719,2.094,3,3,0,0,0,.719,2.094,2.491,2.491,0,0,0,1.937.781,2.184,2.184,0,0,0,1.406-.437A2.115,2.115,0,0,0,7.75-3.734H4.938V-5.594h5.422v1.859A4.882,4.882,0,0,1,8.875-1.187a4.52,4.52,0,0,1-1.453.922A4.824,4.824,0,0,1,5.609.078,5.021,5.021,0,0,1,1.969-1.359Zm0,0" fill="#d9d9d9"/>
        </g>
      </g>
    </g>
    <g id="Group_25" data-name="Group 25">
      <g id="Group_24" data-name="Group 24" transform="translate(131.351 93.275)">
        <g id="Group_23" data-name="Group 23">
          <path id="Path_10" data-name="Path 10" d="M7.406,0,6.859-1.672H3.266L2.719,0H.125L3.594-10.016H6.563L10.016,0ZM3.875-3.531H6.234L5.063-7.078Zm0,0" fill="#d9d9d9"/>
        </g>
      </g>
    </g>
    <g id="Group_28" data-name="Group 28">
      <g id="Group_27" data-name="Group 27" transform="translate(142.91 93.275)">
        <g id="Group_26" data-name="Group 26">
          <path id="Path_11" data-name="Path 11" d="M1.063-9.984H3.5v8.141H6.531V0H1.063Zm0,0" fill="#d9d9d9"/>
        </g>
      </g>
    </g>
    <g id="Group_31" data-name="Group 31">
      <g id="Group_30" data-name="Group 30" transform="translate(151.142 93.275)">
        <g id="Group_29" data-name="Group 29">
          <path id="Path_12" data-name="Path 12" d="M1.063,0V-9.984H3.5V0Zm0,0" fill="#d9d9d9"/>
        </g>
      </g>
    </g>
    <g id="Group_34" data-name="Group 34">
      <g id="Group_33" data-name="Group 33" transform="translate(157.127 93.275)">
        <g id="Group_32" data-name="Group 32">
          <path id="Path_13" data-name="Path 13" d="M7.563-10.016H10V0H7.563L3.5-6.3V0H1.063V-10.016H3.5l4.063,6.3Zm0,0" fill="#d9d9d9"/>
        </g>
      </g>
    </g>
    <g id="Group_37" data-name="Group 37">
      <g id="Group_36" data-name="Group 36" transform="translate(169.61 93.275)">
        <g id="Group_35" data-name="Group 35">
          <path id="Path_14" data-name="Path 14" d="M4.453-8.2a1.128,1.128,0,0,0-.75.25.821.821,0,0,0-.3.688,1.011,1.011,0,0,0,.266.734,1.887,1.887,0,0,0,.7.438c.289.094.613.188.969.281a8.164,8.164,0,0,1,1.063.328,4.735,4.735,0,0,1,.969.469,2.064,2.064,0,0,1,.7.8,2.723,2.723,0,0,1,.266,1.25A2.793,2.793,0,0,1,7.313-.8,4.013,4.013,0,0,1,4.594.094a4.294,4.294,0,0,1-2.7-.8A2.769,2.769,0,0,1,.859-3.016H3.438c.07.8.477,1.2,1.219,1.2a1.163,1.163,0,0,0,.828-.281.938.938,0,0,0,.3-.7.964.964,0,0,0-.266-.7,1.939,1.939,0,0,0-.7-.422c-.293-.1-.617-.2-.969-.281a9.884,9.884,0,0,1-1.062-.344,5.69,5.69,0,0,1-.953-.469,2,2,0,0,1-.7-.8A2.685,2.685,0,0,1,.859-7.047,2.719,2.719,0,0,1,1.891-9.281a4.032,4.032,0,0,1,2.641-.844,4.271,4.271,0,0,1,2.609.734A2.8,2.8,0,0,1,8.188-7.078H5.547a1.326,1.326,0,0,0-.359-.828A.977.977,0,0,0,4.453-8.2Zm0,0" fill="#d9d9d9"/>
        </g>
      </g>
    </g>
    <g id="Group_40" data-name="Group 40">
      <g id="Group_39" data-name="Group 39" transform="translate(180.23 93.275)">
        <g id="Group_38" data-name="Group 38">
          <path id="Path_15" data-name="Path 15" d="M3.5,0H1.063V-9.984H3.5v4.375L6.8-9.984H9.984l-4.109,5L9.984,0H6.859L3.5-4.406Zm0,0" fill="#d9d9d9"/>
        </g>
      </g>
    </g>
    <g id="Group_43" data-name="Group 43">
      <g id="Group_42" data-name="Group 42" transform="translate(191.888 93.275)">
        <g id="Group_41" data-name="Group 41">
          <path id="Path_16" data-name="Path 16" d="M6.094,0H3.672V-3.219L.219-9.984h2.75L4.891-5.469,6.8-9.984H9.563L6.094-3.219Zm0,0" fill="#d9d9d9"/>
        </g>
      </g>
    </g>
    <g id="Group_46" data-name="Group 46">
      <g id="Group_45" data-name="Group 45" transform="translate(96.83 104.107)">
        <g id="Group_44" data-name="Group 44">
          <path id="Path_17" data-name="Path 17" d="M1.047-.484h.641A1.369,1.369,0,0,0,2.719-.859a1.508,1.508,0,0,0,.359-1.063,1.461,1.461,0,0,0-.359-1.047,1.348,1.348,0,0,0-1.031-.391H1.047Zm.641-3.375a2.087,2.087,0,0,1,1.484.531,1.813,1.813,0,0,1,.563,1.406A1.813,1.813,0,0,1,3.172-.516,2.113,2.113,0,0,1,1.688,0H.422V-3.859Zm0,0" fill="#fff"/>
        </g>
      </g>
    </g>
    <g id="Group_49" data-name="Group 49">
      <g id="Group_48" data-name="Group 48" transform="translate(102.445 104.107)">
        <g id="Group_47" data-name="Group 47">
          <path id="Path_18" data-name="Path 18" d="M2.172-.531a1.234,1.234,0,0,0,.953-.391A1.4,1.4,0,0,0,3.5-1.937a1.412,1.412,0,0,0-.375-1.016,1.248,1.248,0,0,0-.953-.391,1.272,1.272,0,0,0-.953.391A1.436,1.436,0,0,0,.859-1.937,1.423,1.423,0,0,0,1.219-.922,1.258,1.258,0,0,0,2.172-.531Zm.016.563A1.952,1.952,0,0,1,.781-.516,1.893,1.893,0,0,1,.2-1.937,1.9,1.9,0,0,1,.781-3.359a1.933,1.933,0,0,1,1.406-.562,1.891,1.891,0,0,1,1.391.563,1.914,1.914,0,0,1,.578,1.422A1.908,1.908,0,0,1,3.578-.516,1.909,1.909,0,0,1,2.188.031Zm0,0" fill="#fff"/>
        </g>
      </g>
    </g>
    <g id="Group_52" data-name="Group 52">
      <g id="Group_51" data-name="Group 51" transform="translate(108.477 104.107)">
        <g id="Group_50" data-name="Group 50">
          <path id="Path_19" data-name="Path 19" d="M2.141.031A1.894,1.894,0,0,1,.781-.516,1.893,1.893,0,0,1,.2-1.937,1.9,1.9,0,0,1,.781-3.359a1.933,1.933,0,0,1,1.406-.562,1.988,1.988,0,0,1,1.094.313,1.727,1.727,0,0,1,.7.859H3.219a1.083,1.083,0,0,0-1.031-.594,1.289,1.289,0,0,0-.969.391A1.436,1.436,0,0,0,.859-1.937,1.423,1.423,0,0,0,1.219-.922a1.249,1.249,0,0,0,.922.375,1.267,1.267,0,0,0,.875-.281,1.307,1.307,0,0,0,.406-.8H1.969v-.5H4.094v.5A1.908,1.908,0,0,1,3.469-.437,1.936,1.936,0,0,1,2.141.031Zm0,0" fill="#fff"/>
        </g>
      </g>
    </g>
    <g id="Group_55" data-name="Group 55">
      <g id="Group_54" data-name="Group 54" transform="translate(117.786 104.107)">
        <g id="Group_53" data-name="Group 53">
          <path id="Path_20" data-name="Path 20" d="M1.609-3.406a.658.658,0,0,0-.453.156.506.506,0,0,0-.172.422.5.5,0,0,0,.2.422,1.454,1.454,0,0,0,.516.2c.2.043.395.094.594.156a1.006,1.006,0,0,1,.516.313.959.959,0,0,1,.219.672A1.019,1.019,0,0,1,2.656-.3a1.386,1.386,0,0,1-.969.328A1.631,1.631,0,0,1,.7-.25a.918.918,0,0,1-.375-.781h.688A.563.563,0,0,0,1.2-.609a.738.738,0,0,0,.484.141A.722.722,0,0,0,2.2-.641a.513.513,0,0,0,.188-.391.5.5,0,0,0-.125-.359.693.693,0,0,0-.3-.187,3.678,3.678,0,0,0-.391-.109c-.148-.039-.293-.082-.437-.125a1.57,1.57,0,0,1-.406-.172.881.881,0,0,1-.3-.313,1.018,1.018,0,0,1-.109-.5,1.023,1.023,0,0,1,.359-.812,1.443,1.443,0,0,1,.953-.312,1.419,1.419,0,0,1,.922.281.993.993,0,0,1,.391.766H2.266a.639.639,0,0,0-.2-.375A.631.631,0,0,0,1.609-3.406Zm0,0" fill="#fff"/>
        </g>
      </g>
    </g>
    <g id="Group_58" data-name="Group 58">
      <g id="Group_57" data-name="Group 57" transform="translate(122.817 104.107)">
        <g id="Group_56" data-name="Group 56">
          <path id="Path_21" data-name="Path 21" d="M2.547-3.875v.5h-1.5V-2.2H2.391v.484H1.047V-.5h1.5V0H.422V-3.875Zm0,0" fill="#fff"/>
        </g>
      </g>
    </g>
    <g id="Group_61" data-name="Group 61">
      <g id="Group_60" data-name="Group 60" transform="translate(127.402 104.107)">
        <g id="Group_59" data-name="Group 59">
          <path id="Path_22" data-name="Path 22" d="M1.047-1.562V0H.422V-3.859H1.75a1.457,1.457,0,0,1,1.016.328,1.036,1.036,0,0,1,.359.813,1.106,1.106,0,0,1-.25.7,1.118,1.118,0,0,1-.719.406L3.188,0H2.406L1.438-1.562Zm0-1.812v1.313h.7a.719.719,0,0,0,.531-.172.618.618,0,0,0,.188-.484A.63.63,0,0,0,2.281-3.2a.736.736,0,0,0-.531-.172Zm0,0" fill="#fff"/>
        </g>
      </g>
    </g>
    <g id="Group_64" data-name="Group 64">
      <g id="Group_63" data-name="Group 63" transform="translate(132.588 104.107)">
        <g id="Group_62" data-name="Group 62">
          <path id="Path_23" data-name="Path 23" d="M1.563,0,.109-3.859H.781l1.141,3.2,1.156-3.2H3.75L2.3,0Zm0,0" fill="#fff"/>
        </g>
      </g>
    </g>
    <g id="Group_67" data-name="Group 67">
      <g id="Group_66" data-name="Group 66" transform="translate(138.119 104.107)">
        <g id="Group_65" data-name="Group 65">
          <path id="Path_24" data-name="Path 24" d="M.422,0V-3.859h.625V0Zm0,0" fill="#fff"/>
        </g>
      </g>
    </g>
    <g id="Group_70" data-name="Group 70">
      <g id="Group_69" data-name="Group 69" transform="translate(141.257 104.107)">
        <g id="Group_68" data-name="Group 68">
          <path id="Path_25" data-name="Path 25" d="M2.188.031A1.952,1.952,0,0,1,.781-.516,1.893,1.893,0,0,1,.2-1.937,1.9,1.9,0,0,1,.781-3.359a1.933,1.933,0,0,1,1.406-.562,1.988,1.988,0,0,1,1.094.313,1.727,1.727,0,0,1,.7.859H3.219a1.083,1.083,0,0,0-1.031-.594,1.289,1.289,0,0,0-.969.391A1.436,1.436,0,0,0,.859-1.937,1.423,1.423,0,0,0,1.219-.922a1.307,1.307,0,0,0,.969.375,1.084,1.084,0,0,0,1.031-.578h.766a1.711,1.711,0,0,1-.7.859A2.042,2.042,0,0,1,2.188.031Zm0,0" fill="#fff"/>
        </g>
      </g>
    </g>
    <g id="Group_73" data-name="Group 73">
      <g id="Group_72" data-name="Group 72" transform="translate(147.228 104.107)">
        <g id="Group_71" data-name="Group 71">
          <path id="Path_26" data-name="Path 26" d="M2.547-3.875v.5h-1.5V-2.2H2.391v.484H1.047V-.5h1.5V0H.422V-3.875Zm0,0" fill="#fff"/>
        </g>
      </g>
    </g>
    <g id="Group_76" data-name="Group 76">
      <g id="Group_75" data-name="Group 75" transform="translate(151.813 104.107)">
        <g id="Group_74" data-name="Group 74">
          <path id="Path_27" data-name="Path 27" d="M1.609-3.406a.658.658,0,0,0-.453.156.506.506,0,0,0-.172.422.5.5,0,0,0,.2.422,1.454,1.454,0,0,0,.516.2c.2.043.395.094.594.156a1.006,1.006,0,0,1,.516.313.959.959,0,0,1,.219.672A1.019,1.019,0,0,1,2.656-.3a1.386,1.386,0,0,1-.969.328A1.631,1.631,0,0,1,.7-.25a.918.918,0,0,1-.375-.781h.688A.563.563,0,0,0,1.2-.609a.738.738,0,0,0,.484.141A.722.722,0,0,0,2.2-.641a.513.513,0,0,0,.188-.391.5.5,0,0,0-.125-.359.693.693,0,0,0-.3-.187,3.678,3.678,0,0,0-.391-.109c-.148-.039-.293-.082-.437-.125a1.57,1.57,0,0,1-.406-.172.881.881,0,0,1-.3-.313,1.018,1.018,0,0,1-.109-.5,1.023,1.023,0,0,1,.359-.812,1.443,1.443,0,0,1,.953-.312,1.419,1.419,0,0,1,.922.281.993.993,0,0,1,.391.766H2.266a.639.639,0,0,0-.2-.375A.631.631,0,0,0,1.609-3.406Zm0,0" fill="#fff"/>
        </g>
      </g>
    </g>
  </g>
</svg>

)}